import * as React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import { useIntl } from 'react-intl';
import AllCarsItem from './AllCarsItem';
import GroupItem from './GroupItem';
import PermissionsService, {
  PERMISSION_VEHICLE_GROUP_CUSTOMER,
  PERMISSION_VEHICLE_GROUP_PRIVATE,
} from '../../../../Services/PermissionsService';
import AllCarsItemStatic from './AllCarsItemStatic';
import GroupItemStatic from './GroupItemStatic';

const Table = SortableContainer((data: any) => {
  const { formatMessage: f } = useIntl();
  const {
    groupItems,
    allItems,
    intl,
    children,
    item,
    allGroupsString,
    handleAllCarsCheckbox,
    selectedUnassignedItems,
    unassignedVehicles,
    handleSearchUnassignedVehicle,
    unassignedVehicleString,
    handleSearchVehicle,
    handleGroupCheckbox,
    selectedAssignedItems,
    assignedVehicles,
    vehicleString,
  } = data;

  let allowed = false;
  if (
    (item.type === 'private' &&
      PermissionsService.hasAccess(
        PERMISSION_VEHICLE_GROUP_PRIVATE,
        ['update'],
        item.customerId
      )) ||
    (item.type === 'public' &&
      PermissionsService.hasAccess(PERMISSION_VEHICLE_GROUP_CUSTOMER, ['update'], item.customerId))
  ) {
    allowed = true;
  }
  const thisGroup = item.id;

  React.useEffect(() => {
    const checkbox: any = document.getElementById(`checkboxAll-${item.id}`);
    if (checkbox && unassignedVehicles.length > 0) {
      if (selectedUnassignedItems.length === 0) {
        checkbox.indeterminate = false;
        checkbox.checked = false;
      } else if (
        unassignedVehicles.length === selectedUnassignedItems.length &&
        selectedUnassignedItems.length > 0
      ) {
        checkbox.indeterminate = false;
        checkbox.checked = true;
      } else {
        checkbox.indeterminate = true;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUnassignedItems.length]);

  React.useEffect(() => {
    const checkbox: any = document.getElementById(`checkboxGroup-${item.id}`);
    if (checkbox && assignedVehicles.length > 0) {
      if (selectedAssignedItems.length === 0) {
        checkbox.indeterminate = false;
        checkbox.checked = false;
      } else if (
        assignedVehicles.length === selectedAssignedItems.length &&
        selectedAssignedItems.length > 0
      ) {
        checkbox.indeterminate = false;
        checkbox.checked = true;
      } else {
        checkbox.indeterminate = true;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAssignedItems.length]);

  return (
    <div className="row row--size-sm flex-lg-nowrap">
      <div className="col-12 col-lg mb-2">
        <div className="row row--size-sm mb-xs position-relative top-2 mb-2">
          <div className="col-xl-5">
            <div className="e-checkbox px-2 py-1 d-block position-relative bottom-1">
              {allowed ? (
                <label>
                  <input
                    onChange={handleAllCarsCheckbox}
                    data-id={item.id}
                    className="js-checkbox-indeterminate"
                    type="checkbox"
                    data-cy={`checkbox-unassigned-${item.name}-${item.id}`}
                    id={`checkboxAll-${item.id}`}
                  />
                  <span className="font-weight-bold pl-6">
                    {f({ id: 'carsGroups.availableCars' })} ({unassignedVehicles.length})
                  </span>
                </label>
              ) : (
                <span className="font-weight-bold">
                  {f({ id: 'carsGroups.availableCars' })} ({unassignedVehicles.length})
                </span>
              )}
            </div>
          </div>
          <div className="col-xl-7 mb-3 mb-lg-0">
            <span>
              <input
                onChange={handleSearchUnassignedVehicle}
                data-cy="input-search-unassigned"
                // value={unassignedVehicleString}
                type="text"
                className="form-control border-radius-0"
                id="input-1"
                placeholder={f({ id: 'carsGroups.chooseCar' })}
                title={f({ id: 'carsGroups.chooseCar.tooltip' })}
              />
            </span>
          </div>
        </div>

        <div
          id="allCars"
          className={`table-responsive ${allowed ? 'table-drag' : ''}`}
          style={{
            overflowY: 'auto',
            overflowX: 'hidden',
            height: '500px',
            marginTop: '15px',
            border: '1px solid #ccc',
          }}
        >
          <div className="d-block d-lg-table d-md-table e-table-desktop table table-striped car-groups-listings mb-0 carsGroupsItems">
            {allowed ? (
              Object.values(allItems).map((subItem: any) => (
                <AllCarsItem
                  item={subItem}
                  thisGroup={thisGroup}
                  key={subItem.vehicleId}
                  index={subItem.vehicleId}
                  value={subItem.name}
                  intl={intl}
                  vehicleString={unassignedVehicleString}
                  allGroupsString={allGroupsString}
                />
              ))
            ) : (
              <AllCarsItemStatic id={item.id} allItems={unassignedVehicles} intl={intl} />
            )}
          </div>
        </div>
      </div>

      {allowed && children}

      <div className="col-12 col-lg mb-2">
        <div className="row row--size-sm mb-xs position-relative top-2 mb-2">
          <div className="col-xl-5">
            <div className="e-checkbox px-2 py-1 d-block position-relative bottom-1">
              {allowed ? (
                <label>
                  <input
                    onChange={handleGroupCheckbox}
                    data-id={item.id}
                    type="checkbox"
                    data-cy={`checkbox-assigned-${item.name}-${item.id}`}
                    id={`checkboxGroup-${item.id}`}
                    className="js-checkbox-indeterminate"
                  />
                  <span className="font-weight-bold pl-6">
                    {f({ id: 'carsGroups.groupVehicles' })} ({assignedVehicles.length})
                  </span>
                </label>
              ) : (
                <span className="font-weight-bold">
                  {f({ id: 'carsGroups.groupVehicles' })} ({assignedVehicles.length})
                </span>
              )}
            </div>
          </div>
          <div className="col-xl-7 mb-3 mb-lg-0 d-inline-block d-md-block">
            <span>
              <input
                onChange={handleSearchVehicle}
                data-cy="input-search-assigned"
                // value={vehicleString}
                type="text"
                className="form-control border-radius-0"
                id="input-1"
                placeholder={f({ id: 'carsGroups.chooseCar' })}
                title={f({ id: 'carsGroups.chooseCar.tooltip' })}
              />
            </span>
          </div>
        </div>
        <div
          id="thisGroup"
          className={`table-responsive ${allowed ? 'table-drag' : ''}`}
          style={{
            overflowY: 'auto',
            overflowX: 'hidden',
            height: '500px',
            marginTop: '15px',
            border: '1px solid #ccc',
          }}
        >
          <div className="d-block d-lg-table d-md-table e-table-desktop table table-striped car-groups-listings mb-0 carsGroupsItems">
            {allowed ? (
              Object.values(groupItems).map((grouItem: any) => (
                <GroupItem
                  item={grouItem}
                  thisGroup={thisGroup}
                  key={grouItem.vehicleId}
                  index={grouItem.vehicleId}
                  value={grouItem.name}
                  intl={intl}
                  vehicleString={vehicleString}
                  allGroupsString={allGroupsString}
                />
              ))
            ) : (
              <GroupItemStatic id={item.id} groupItems={assignedVehicles} intl={intl} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default Table;
